import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './Lightbox.css';

const Lightbox = ({ baslik, icerik, onClose }) => {
  return (
    <div className="lightbox-overlay" onClick={onClose}>
      <div className="lightbox-content" onClick={e => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose} aria-label="Kapat">
          <FaTimes />
        </button>
        <h2>{baslik}</h2>
        <div className="lightbox-body" dangerouslySetInnerHTML={{ __html: icerik }} />
      </div>
    </div>
  );
};

export default Lightbox;
